import React from 'react';
import './MonitorSection.css';

const MonitorSection: React.FC = () => {
  return (
    <section id="monitor" className="monitor-section">
      <div className="monitor-container">
        <div className="monitor-content">
          <div className="monitor-left">
            <div className="monitor-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                <path d="M21 16H3V4H1v12c0 1.1.9 2 2 2h18v-2zM23 6v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2z" fill="currentColor"/>
                <path d="M7 8h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z" fill="currentColor"/>
              </svg>
            </div>
            <h2 className="monitor-title">Monitor everything</h2>
            <p className="monitor-description">
              Get real-time insights into your telephony operations with comprehensive monitoring, 
              analytics, and instant alerts for any issues that arise.
            </p>
            <button className="monitor-cta">View Dashboard</button>
          </div>
          
          <div className="monitor-right">
            <h3 className="failover-title">Native failover alerts.</h3>
            <ul className="failover-list">
              <li className="failover-item">
                <span className="alert-icon">🔴</span>
                SIP Trunk is down
              </li>
              <li className="failover-item">
                <span className="alert-icon">🟡</span>
                Call quality is poor
              </li>
              <li className="failover-item">
                <span className="alert-icon">🟠</span>
                High latency detected
              </li>
              <li className="failover-item">
                <span className="alert-icon">🔵</span>
                Agent availability low
              </li>
              <li className="failover-item">
                <span className="alert-icon">🟣</span>
                Network congestion
              </li>
            </ul>
          </div>
        </div>
        
        <div className="monitor-table">
          <div className="table-header">
            <div className="table-cell">Monitoring Feature</div>
            <div className="table-cell">Status</div>
          </div>
          <div className="table-row">
            <div className="table-cell">Real-time Analytics</div>
            <div className="table-cell">
              <span className="status-check">✓</span>
            </div>
          </div>
          <div className="table-row">
            <div className="table-cell">Performance Metrics</div>
            <div className="table-cell">
              <span className="status-check">✓</span>
            </div>
          </div>
          <div className="table-row">
            <div className="table-cell">Alert System</div>
            <div className="table-cell">
              <span className="status-check">✓</span>
            </div>
          </div>
          <div className="table-row">
            <div className="table-cell">Failover Detection</div>
            <div className="table-cell">
              <span className="status-check">✓</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MonitorSection;
